import { configureStore } from '@reduxjs/toolkit'

import { 
    ReducerAuth, ReducerCompany,
    ReducerDrawer, 
    ReducerPlan, ReducerPlanGroup, 
    ReducerApplicationService, ReducerAccessKey } from './reducers'

export default configureStore({
    reducer: {
        auth: ReducerAuth,
        company: ReducerCompany,
        drawer: ReducerDrawer,
        plans: ReducerPlan,
        planGroups: ReducerPlanGroup,
        applicationServices: ReducerApplicationService,
        accessKeys: ReducerAccessKey
    },
    devTools: process.env.NODE_ENV !== 'production'
})